<template>
  <div class="date-container">
    <div class="dates">
      <div class="line" v-for="i in beforeLength" :key="'line-up' + i"></div>
      <div @click="navigateTo(date)" v-for="(date,index) in visibleDates" class="date" :key="'date-' + index">
        <div class="date-label" :class="{ selected: isSelected(date) }">{{ getLabel(date) }}</div>
        <div class="date-symbol-container">
          <div class="date-symbol" :class="{ selected: isSelected(date) }"></div>
        </div>
      </div>
      <div class="line" v-for="j in afterLength" :key="'line-down' +j"></div>

    </div>
    <div class="date-gradient top"></div>
    <div class="date-gradient bottom"></div>
  </div>
</template>

<script>
export default {
  methods: {
    getLabel (date) {
      const dateLabel = (typeof date) === 'string' ? date : date[0]
      const dateArray = dateLabel.split('_')
      const currentYear = dateArray[0]
      const firstOfTheYear = this.dates.find(date => date.split('_')[0] === currentYear)
      return firstOfTheYear === dateLabel ? currentYear : ''
    },
    isSelected (date) {
      return date === this.selected
    },
    navigateTo (dateSelected) {
      const index = this.dates.findIndex(date => date === dateSelected)
      this.$emit('navigateTo', this.events[index].slug)
    }
  },
  props: ['id'],
  data () {
    return {
      // selected: '1900',
      events: this.$store.getters.storyData,
      dates: this.$store.getters.storyData.map(event => event.date)
    }
  },
  computed: {
    selected () {
      const slug = this.id ? this.id : this.$router.currentRoute.hash.substring(1)
      return this.events.find(event => event.slug === slug).date
    },
    datesLength () {
      return this.dates.length
    },
    selectedIndex () {
      return this.dates.findIndex(date => date === this.selected)
    },
    min () {
      return this.selectedIndex - 6 > 0 ? this.selectedIndex - 6 : 0
    },
    max () {
      return this.selectedIndex + 4 < this.dates.length ? this.selectedIndex + 4 : this.dates.length - 1
    },
    visibleDates () {
      return this.dates.slice(this.min, this.max + 1)
    },
    beforeLength () {
      return this.min === 0 ? (20 - this.max) : 10
    },
    afterLength () {
      return this.min > 0 ? 20 - (this.max - this.min) : 0
    }

  }
}
</script>

<style lang="scss">
  .date-container {
    position: relative;
    // height: 100%;
    .date-gradient {
      height: 80px;
      width: 64px;
      pointer-events: none;
      position: absolute;
    }
    .date-gradient.top {
      top: 0;
      background-image: linear-gradient(to top, rgba(241, 241, 240, 0), #f1f1f0);
    }
    .date-gradient.bottom {
      bottom: 0;
      background-image: linear-gradient(to bottom, rgba(241, 241, 240, 0), #f1f1f0);
    }
    .dates {
      position: relative;
      .line {
          position: relative;
          left: 55.5px;
          width: 1px;
          height: 16px;
          opacity: 0.1;
          background-color: #18333c;
      }
      position: relative;
      .date {
        display: flex;
        flex-direction: row;
        cursor: pointer;
        height: 16px;
        .date-label {
          width: 32px;
          font-family: Charter;
          font-weight: bold;
          font-size: 10px;
          line-height: 1.6;
          letter-spacing: normal;
          color: #7d939a;
          text-align: right;
        }
        .date-label.selected {
          color: black
        }
        .date-symbol-container {
          width: 32px;
          .date-symbol {
            width: 4px;
            height: 4px;
            transform: rotate(45deg);
            margin-left: 22px;
            margin-top: 6px;
            background-color: #7d939a;
          }
          .date-symbol.selected{
            width: 8px;
            height: 8px;
            margin-left: 20px;
            margin-top: 4px;
            background-color: #18333c;
          }
        }
      }
      .date:hover {
          .date-symbol {
            width: 6px;
            height: 6px;
            margin-left: 20px;
            margin-top: 4px;
            background-color: transparent;
            border: solid 1px #18333c;
          }
      }
    }
  }
</style>
